var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "over_layout" }, [
    _c("section", { staticClass: "upgrade" }, [
      _c(
        "a",
        {
          staticStyle: { cursor: "pointer" },
          on: {
            click: function($event) {
              return _vm.$store.commit("paymentModal", true)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "faq" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pages_header" }, [
          _c("div", { staticClass: "lines" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$store.getters.t("FAQ")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c(
              "p",
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.translations[_vm.$store.getters.locale]["start"]
                    ) +
                    "\n            "
                ),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "contacts",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.translations[_vm.$store.getters.locale]["right_us"]
                      )
                    )
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.translations[_vm.$store.getters.locale]["end"]) +
                    "\n          "
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "questions_blocks" }, [
        _c(
          "div",
          { staticClass: "wrapper" },
          _vm._l(_vm.faq, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "block",
                attrs: { id: item["faq_transliations"][0]["slug"] }
              },
              [
                _c(
                  "div",
                  { staticClass: "questions", on: { click: _vm.show } },
                  [_vm._v(_vm._s(item["faq_transliations"][0]["question"]))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "answer" }, [
                  _c("div", { staticClass: "text_area" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          item["faq_transliations"][0]["answer"]
                        )
                      }
                    })
                  ])
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "write_us" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "form_block" }, [
            _c(
              "form",
              {
                attrs: { method: "POST" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.sendQuestion($event)
                  }
                }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:3",
                      expression: "'required|min:3'"
                    }
                  ],
                  staticClass: "inp_type",
                  class: _vm.errors.first("name") ? "invalid" : "",
                  attrs: {
                    type: "text",
                    name: "name",
                    placeholder: _vm.$store.getters.t("name"),
                    required: ""
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  staticClass: "inp_type",
                  class: _vm.errors.first("email") ? "invalid" : "",
                  attrs: {
                    type: "email",
                    name: "email",
                    placeholder: _vm.$store.getters.t("email"),
                    required: ""
                  }
                }),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  class: _vm.errors.first("question") ? "invalid" : "",
                  attrs: {
                    name: "question",
                    placeholder: _vm.$store.getters.t("write_us")
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "inp_send",
                  attrs: { type: "submit" },
                  domProps: { value: _vm.$store.getters.t("send") }
                })
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aab4af0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aab4af0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Faq.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5aab4af0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Faq.vue
// module chunks = 0